import { isObjectEmpty } from './object.helpers'

/**
 * Verifica se um elemento está vazio.
 * @param {*} element - O elemento a ser verificado.
 * @return {boolean} Retorna true se o elemento estiver vazio, caso contrário, retorna false.
 */
export function isEmpty(element) {
  return (
    element === '' ||
    element === undefined ||
    element === null ||
    element === 'undefined' ||
    isObjectEmpty(element) ||
    /^\s*$/.test(element)
  )
}

export function boldText(text: string) {
  if (typeof text !== 'string') return text
  return text.replace(/\*(.*?)\*/g, '<b>$1</b>')
}

export function escapeHtml(text: string) {
  if (typeof text !== 'string') return text
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,!?;:'")\]]|www\.[^\s<]+[^\s<.,!?;:'")\]])/gi

export function linkifyText(text: string) {
  if (typeof text !== 'string') return text
  return text.replace(URL_REGEX, url => {
    const href = url.toLowerCase().startsWith('www.') ? `https://${url}` : url
    return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:#00A884;text-decoration:underline !important">${url}</a>`
  })
}

export function formatMessageText(text: string) {
  if (typeof text !== 'string') return text
  return linkifyText(boldText(escapeHtml(text)))
}

const SINGLE_URL_REGEX = /^(https?:\/\/[^\s<]+|www\.[^\s<]+)$/i

export function extractSingleUrl(text: string): { href: string; hostname: string } | null {
  if (typeof text !== 'string') return null
  const trimmed = text.trim()
  if (!SINGLE_URL_REGEX.test(trimmed)) return null
  const href = trimmed.toLowerCase().startsWith('www.') ? `https://${trimmed}` : trimmed
  try {
    return { href, hostname: new URL(href).hostname }
  } catch {
    return null
  }
}

/**
 * @param names - Array of names
 * @returns string - List of names separated by comma and 'e' for the last name
 * @example
 * getListOfNames(['John', 'Doe', 'Foo']) // 'John, Doe e Foo'
 * getListOfNames(['John', 'Doe']) // 'John e Doe'
 * getListOfNames(['John']) // 'John'
 */
export function getListOfNames(names: string[]) {
  if (!names?.length) {
    return ''
  }

  let lastName: string

  names.length > 1 && (lastName = names.pop())

  return `${names.join(', ')} ${lastName ? ` e ${lastName}` : ''}`
}

export function capitalizeFirstLetter(str: string) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function normalizeSearchText(text: string): string {
  if (typeof text !== 'string') return ''
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
}

const PHONE_LIKE_REGEX = /^[\d()\-.\s+]+$/

export function buildChatSearchTerm(rawValue: string): string {
  if (typeof rawValue !== 'string') return ''
  const trimmed = rawValue.trim()
  if (trimmed && PHONE_LIKE_REGEX.test(trimmed)) {
    return trimmed.replace(/[^\d]/g, '')
  }
  return rawValue.toLocaleLowerCase()
}
